export default {
    path: '/jobs',
    redirect: to => {
        return { path: '/start/general-flow', query: { job: to.query.job } };
    },
};
